import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Newspaper, Image, Sparkles, FileText, Users, UserCircle, Mail, HandHeart } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { key: "news", label: "Berita", icon: Newspaper, color: "bg-[var(--brand-blue)]", to: "/admin/news" },
    { key: "gallery", label: "Item Galeri", icon: Image, color: "bg-[var(--brand-orange)]", to: "/admin/gallery" },
    { key: "programs", label: "Program", icon: Sparkles, color: "bg-emerald-600", to: "/admin/programs" },
    { key: "publications", label: "Publikasi", icon: FileText, color: "bg-purple-600", to: "/admin/publications" },
    { key: "partners", label: "Mitra", icon: Users, color: "bg-cyan-600", to: "/admin/partners" },
    { key: "team", label: "Tim", icon: UserCircle, color: "bg-pink-600", to: "/admin/team" },
    { key: "pages", label: "Halaman Kustom", icon: HandHeart, color: "bg-indigo-600", to: "/admin/pages" },
    { key: "volunteer_submissions", label: "Pendaftaran Volunteer", icon: HandHeart, color: "bg-amber-600", to: "/admin/submissions" },
    { key: "contact_submissions", label: "Pesan Kontak", icon: Mail, color: "bg-slate-700", to: "/admin/submissions" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-3xl font-bold text-slate-900">Dashboard</h1>
      <p className="text-slate-600 mt-1">Selamat datang di panel admin Sauyunan Foundation.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {cards.map((c) => (
          <Link key={c.key} to={c.to} className="card-sf p-6 hover:border-[var(--brand-blue)]/40 transition group" data-testid={`dashboard-card-${c.key}`}>
            <div className={`h-10 w-10 rounded-xl ${c.color} text-white flex items-center justify-center mb-4`}>
              <c.icon className="h-5 w-5" />
            </div>
            <div className="text-3xl font-bold text-slate-900">{stats?.[c.key] ?? "—"}</div>
            <div className="mt-1 text-sm text-slate-600">{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="mt-6 rounded-2xl bg-gradient-to-br from-[var(--brand-blue)] to-[#254DAA] p-6 text-white">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div>
            <h3 className="text-lg font-bold">Kelola Situs</h3>
            <p className="text-sm text-slate-200 mt-1">Edit header, hero, footer, kontak, dan rekening di satu tempat.</p>
          </div>
          <Link to="/admin/site-settings" className="inline-flex items-center gap-2 rounded-full bg-white text-[var(--brand-blue)] px-5 py-2.5 text-sm font-semibold hover:bg-[var(--brand-orange)] hover:text-white transition">
            Buka Pengaturan Situs →
          </Link>
        </div>
      </div>

      <div className="mt-10 grid lg:grid-cols-2 gap-6">
        <div className="card-sf p-6">
          <h3 className="text-lg font-bold text-slate-900 mb-3">Panduan Cepat</h3>
          <ul className="space-y-2 text-sm text-slate-700">
            <li>• <strong>Berita</strong>: Publikasikan artikel & kabar terbaru dengan cover image, kategori, dan tag.</li>
            <li>• <strong>Galeri</strong>: Upload foto/video kegiatan dengan kategori terfilter.</li>
            <li>• <strong>Program</strong>: Kelola 7 bidang program strategis + sub-program.</li>
            <li>• <strong>Publikasi</strong>: Upload Annual Report, Financial Report, Research (PDF).</li>
            <li>• <strong>Submissions</strong>: Lihat pendaftaran relawan & pesan kontak.</li>
          </ul>
        </div>

        <div className="card-sf p-6">
          <h3 className="text-lg font-bold text-slate-900 mb-3">Status Sistem</h3>
          <div className="space-y-2 text-sm">
            <div className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-emerald-500" /> Backend API terhubung</div>
            <div className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-emerald-500" /> MongoDB aktif</div>
            <div className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-emerald-500" /> Email service terhubung (Resend)</div>
          </div>
        </div>
      </div>
    </div>
  );
}
